import { useAppDispatch, useAppSelector } from "app/hooks"
import { useFailed, useSuccess } from "features/notification/hooks"
import { useEffect, useState } from "react"
import { getDailyScanProgress, logScannedFoods } from "../mealSlice"
import { LogMealStepType } from "../mealSlice.types"
import { ICreateMealPayload } from "model/food/types/mealPayload.types"

export const useDailyScanProgress = (step: LogMealStepType) => {
  const [isRequestSend, setIsRequestSend] = useState(false)

  const dailyScanProgress = useAppSelector(
    (state) => state.meal.dailyScanProgress,
  )
  const getDailyScanProgressLoading = useAppSelector(
    (state) => state.meal.getDailyScanProgressLoading,
  )
  const getDailyScanProgressFailed = useAppSelector(
    (state) => state.meal.getDailyScanProgressFailed,
  )

  useFailed(getDailyScanProgressFailed)

  const dispatch = useAppDispatch()

  useEffect(() => {}, [])

  useEffect(() => {
    if (step === "take-photo") {
      dispatch(getDailyScanProgress())
      setTimeout(() => {
        setIsRequestSend(true)
      }, 500)
    }
    
    if (step !== "take-photo" && isRequestSend) {
      setIsRequestSend(false)
    }
  }, [step])

  const isScanDisabled =
    !dailyScanProgress ||
    dailyScanProgress.remainingScan === 0 ||
    getDailyScanProgressLoading

  const isNoRemainingScan =
    isRequestSend &&
    !getDailyScanProgressLoading &&
    dailyScanProgress?.remainingScan === 0

  return {
    dailyScanProgress,
    getDailyScanProgressLoading,
    isScanDisabled,
    isNoRemainingScan,
  }
}

export const useLogScannedFoods = (callback?: () => void) => {
  const logScannedFoodsLoading = useAppSelector(
    (state) => state.meal.logScannedFoodsLoading,
  )
  const logScannedFoodsFailed = useAppSelector(
    (state) => state.meal.logScannedFoodsFailed,
  )
  const logScannedFoodsSuccess = useAppSelector(
    (state) => state.meal.logScannedFoodsSuccess,
  )

  const dispatch = useAppDispatch()

  const handleLogScannedFoods = (foods: ICreateMealPayload[]) => {
    dispatch(logScannedFoods(foods))
  }

  useFailed(logScannedFoodsFailed)

  useSuccess(logScannedFoodsSuccess, { message: "" }, callback)

  return { logScannedFoodsLoading, handleLogScannedFoods }
}
